import { useDispatch } from 'react-redux'

import { useQueryState } from 'nuqs'

import { openIncidentDrawer, setIncident } from '@/redux/ui/uiSlice'

type openIncidentArgs = {
  incidentId: string
  displayId: string
}

export const useOpenIncident = () => {
  const dispatch = useDispatch()
  const [, setDisplayId] = useQueryState('displayId')

  const openAlertIncidentDrawer = (id: string) => {
    dispatch(setIncident({ id }))
    dispatch(openIncidentDrawer())
  }

  const openIncident = (args: openIncidentArgs) => {
    openAlertIncidentDrawer(args.incidentId)
    setDisplayId(args.displayId)
  }

  return { openIncident, setDisplayId, openAlertIncidentDrawer }
}
